import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  reservationTrendsData: {},
  loading: false,
  error: null,
};

const reservationTrendsSlice = createSlice({
  name: "reservationTrends",
  initialState,
  reducers: {
    fetchReservationTrendsSuccess: (state, action) => {
      state.loading = false;
      state.reservationTrendsData = action.payload;
    },
    fetchReservationTrendsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchReservationTrendsSuccess, fetchReservationTrendsFailure } =
  reservationTrendsSlice.actions;

export default reservationTrendsSlice.reducer;
